module.exports = __webpack_public_path__ + "static/2-aab48f50965e37d57ec3446cb37a1f16.jpg";